export enum SkillFrequency {
  Never = 0,
  Monthly = 1,
  Weekly = 2,
  Daily = 3,
}
